import React from "react";
import styles from "./Spinner.module.css";

const Spinner = () => (
  <img src="/assets/spinner.png" alt="spinner" className={styles.spinner} />
);

export default Spinner;
